import { createContext, useContext, useState, ReactNode } from 'react'

interface ChatPanelContextType {
  isOpen: boolean
  openPanel: () => void
  closePanel: () => void
  togglePanel: () => void
}

const ChatPanelContext = createContext<ChatPanelContextType | undefined>(undefined)

export function ChatPanelProvider({ children }: { children: ReactNode }) {
  const CHAT_PANEL_VISIBLE_KEY = 'clnicl_chat_panel_visible'
  
  const [isOpen, setIsOpenState] = useState(() => {
    const saved = localStorage.getItem(CHAT_PANEL_VISIBLE_KEY)
    return saved !== null ? saved === 'true' : false
  })

  const setIsOpen = (open: boolean) => {
    setIsOpenState(open)
    localStorage.setItem(CHAT_PANEL_VISIBLE_KEY, String(open))
  }

  const openPanel = () => setIsOpen(true)
  const closePanel = () => setIsOpen(false)
  const togglePanel = () => setIsOpen(!isOpen)

  return (
    <ChatPanelContext.Provider
      value={{
        isOpen,
        openPanel,
        closePanel,
        togglePanel,
      }}
    >
      {children}
    </ChatPanelContext.Provider>
  )
}

export function useChatPanel() {
  const context = useContext(ChatPanelContext)
  if (context === undefined) {
    throw new Error('useChatPanel must be used within a ChatPanelProvider')
  }
  return context
}
































